import { t } from '../../../i18n.es.js';
import React from 'react';
import { Flex, Box } from 'reflexbox';
import { styled, SvgIcon } from '@teko/ui';
import { PromotionType } from '../../../types.es.js';
import { PromotionInfo } from '../../Promotion/PromotionInfo/PromotionInfo.es.js';

const Coupon = styled.div`
  text-transform: uppercase;
  padding: 0 6px;
  margin: 0 4px;
  background-color: #ef2741;
  color: #fff;
  border-radius: 2px;
  display: inline-block;
`;
const StyledIcon = styled(SvgIcon)(({ theme }) => `
  margin-left: 5px;
  --button-icon-color: ${theme == null ? void 0 : theme.brand.primary};
  `);
const DiscountPromotion = ({
  promotion
}) => {
  var _a, _b;
  if (!promotion || !((_a = promotion.benefit.money) == null ? void 0 : _a.length))
    return null;
  return /* @__PURE__ */ React.createElement(Flex, {
    marginTop: 2
  }, /* @__PURE__ */ React.createElement(Box, {
    width: "8%"
  }, /* @__PURE__ */ React.createElement(StyledIcon, {
    name: "promotion",
    size: 20
  })), /* @__PURE__ */ React.createElement(Box, {
    width: "92%"
  }, promotion.type === PromotionType.COUPON && /* @__PURE__ */ React.createElement(React.Fragment, null, t("\u0110\xE3 \xE1p d\u1EE5ng m\xE3 gi\u1EA3m gi\xE1"), " ", /* @__PURE__ */ React.createElement(Coupon, null, " ", ((_b = promotion.condition) == null ? void 0 : _b.coupon) || "", " "), " ", t("gi\u1EA3m"), /* @__PURE__ */ React.createElement(PromotionInfo, {
    money: promotion.benefit.money[0],
    condition: promotion.condition || null
  })), promotion.type === PromotionType.PRODUCT && /* @__PURE__ */ React.createElement(React.Fragment, null, t("Gi\u1EA3m tr\u1EF1c ti\u1EBFp"), " ", /* @__PURE__ */ React.createElement(PromotionInfo, {
    money: promotion.benefit.money[0],
    condition: promotion.condition || null
  }))));
};

export { DiscountPromotion };
